/* globals scriptVariables */

import loadGoogleMapsApi from 'load-google-maps-api';
import MarkerClusterer from '@google/markerclustererplus';

export default class LocationViewer {
	constructor(element){
		this.wrapper = typeof(element) === 'string' ? document.querySelector(element) : element;
		this.tabs 	 = this.wrapper.querySelector('.tabs');
		this.mapEle  = this.wrapper.querySelector('.map');
		this.colours = [];

		if(this.tabs === null){
			throw new Error('Tabs element cannot be found.');
		}

		if(this.mapEle === null){
			throw new Error('Map element cannot be found.');
		}

		if(typeof this.wrapper.dataset.markers === 'undefined'){
			throw new Error('Markers data attribute is empty');
		}

		if(typeof this.wrapper.dataset.colours === 'undefined'){
			throw new Error('Markers colours attribute is empty');
		}

		this.markersJSON = JSON.parse(this.wrapper.dataset.markers);
		this.colours = JSON.parse(this.wrapper.dataset.colours);
		this.markersArr = [];
		this.clustersArr = [];

		this.defaultClusterObj = {
			anchorIcon: [86, 30],
			anchorText: [50, 24],
			width: 60,
			height: 86,
			fontFamily: "'fsalbert', sans-serif",
			fontWeight: 'bold',
			textSize: 16,
			textColor: 'white'
		};

		loadGoogleMapsApi({key: 'AIzaSyAc4qeSw9vL5jXPnI12LbPKI7KnoZm5Sa4' }).then(mapsApi => {
			this.api = mapsApi;

			this.infowindow = new mapsApi.InfoWindow({
				content: 'dsfdsfdsfs',
				pixelOffset: new mapsApi.Size(-30, -28),
				maxWidth: 400
			});

			this.initMap();
		});

	}

	initMap(){
		this.map = new this.api.Map(this.mapEle, {
			center: {lat: parseFloat(51.458834), lng: parseFloat(-2.588586)},
			zoom: 6,
			styles: [
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#333333"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#f6f6f6"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ebebec"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e2d3dc"
						},
						{
							"lightness": "0"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#d0b1c4"
						},
						{
							"lightness": "00"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f2f2f2"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#b781a0"
						},
						{
							"lightness": "0"
						}
					]
				}
			]
		});

		Object.keys(this.markersJSON).forEach((key, index) => {

			this.markersArr.push(this.createMarkers(this.markersJSON[key]['locations'], this.colours[key]));

			this.clustersArr[index] = new MarkerClusterer(this.map, this.markersArr[index], {
				imagePath: scriptVariables.home_url + '/wp-content/themes/class/dist/images/icons/marker--' + this.colours[key],
				styles: this.createClusterStyles(this.colours[key])
			});

		});

		this.initTabs();
	}

	createClusterStyles(colour){
		let loop = [1,2,3,4,5],
			obj  = [];

		loop.forEach(el => {
			obj.push(Object.assign({ url: scriptVariables.home_url + '/wp-content/themes/class/dist/images/icons/marker--' + colour + '.png' }, this.defaultClusterObj));
		});

		return obj;
	}

	createMarkers(arr, colour){
		let markerArr = arr.map((location, i) => {
			let addressformatted = location['address'].replace(new RegExp(', ', 'g'), ', <br />');
			let marker = new this.api.Marker({
				position: { lat: parseFloat(location['lat']), lng: parseFloat(location['lng']) },
				// label: location['title'],
				icon: {
					url 		: scriptVariables.home_url + '/wp-content/themes/class/dist/images/icons/marker--'+ colour +'.png',
					size 		: new this.api.Size(120, 172),
					scaledSize 	: new this.api.Size(60, 86), // smaller
					origin 		: new this.api.Point(0, 0),
					anchor 		: new this.api.Point(30, 86)
				}
			});
			marker.addListener('click', ev => {
				this.infowindow.setContent(`
					<div id="infowindow-content">
						<h3>${location['title']}</h3>
						<p class="address">${addressformatted}</p>
					</div>
				`);
				//<p>${location['tel']}</p>
				//<p>${location['contact']}</p>

				DOMTokenList.prototype.remove.apply(this.mapEle.classList, Object.values(this.colours).map(color => 'map--' + color));
				this.mapEle.classList.add('map--' + colour);
				this.infowindow.open(this.map, marker);
			});

			return marker;
		});

		return markerArr;
	}

	initTabs(){
		this.tabs.querySelectorAll('button').forEach(el => {
			el.addEventListener('click', ev => {
				ev.preventDefault();

				let liEle = ev.target.parentNode,
					index = [...liEle.parentNode.children].indexOf(liEle);

				if(ev.target.classList.contains('tab--active')){
					this.removeMarkers(index);
				} else {
					this.addMarkers(index);
				}

				ev.target.classList.toggle('tab--active');
			});
		});
	}

	addMarkers(index){
		this.clustersArr[index].addMarkers(this.markersArr[index]);
		this.clustersArr[index].repaint();
	}

	removeMarkers(index){
		this.clustersArr[index].removeMarkers(this.markersArr[index]);
		this.clustersArr[index].repaint();
	}
}
